import script from "./OriginalReference.vue?vue&type=script&setup=true&lang=ts"
export * from "./OriginalReference.vue?vue&type=script&setup=true&lang=ts"

import "./OriginalReference.vue?vue&type=style&index=0&id=72bce1ab&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72bce1ab"]])

export default __exports__